import React from 'react';

const ConditionSection = ({ conditionData }) => {
    return (
        <section className="condition-section">
            <div className="container">
                <div className="inner-content">
                    <div className="content-wrapper">
                        <div className="top-row row-change">
                            <div className="left-wrap">
                                <img src={conditionData.image} alt="Commercial Inspection" />
                            </div>
                            <div className="right-wrap">
                                <h2>{conditionData.heading}</h2>
                                <p>{conditionData.intro}</p>
                                
                            </div>
                        </div>
                        <div className="bottom-wrap">
                            <p>{conditionData.overview}</p>
                            <p>{conditionData.introNote}</p>
                            {conditionData.types.map((item, index) => (
                                <div className="p-data-wrap" key={index}>
                                    <p>
                                        {item.title && <b>{item.title}</b>}
                                        {item.text}
                                    </p>
                                </div>
                            ))}
                            <ul>
                                {conditionData.checklist.map((point, index) => (
                                    <li key={index}>{point}</li>
                                ))}
                            </ul>
                            <div className="b-data">
                                <p>{conditionData.summary}</p>
                            </div>
                            <div className="bottom-p think-p">
                                <p>{conditionData.standards}</p>
                            </div>
                            <div className="bottom-p">
                                <p>{conditionData.contactNote}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConditionSection;
